export { SandBoxState } from "../../middleware/Constants/DeveloperConstant";
export { LOGIN_PATH, LOGOUT_PATH } from "./GlobalConstant";

export const SandBoxWebClientPrefix = "web-";
export const SandBoxUrlQueryKey = "sandbox";